import { lazyLoad } from 'utils/loadable';
import LoadingSpinner from 'app/components/Loading/LoadingSpinner';

export const WelcomeEmail = lazyLoad(
    () => import('./index'),
    module => module.WelcomeEmail,
    { fallback: <LoadingSpinner /> },
);
